import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './employeepage.css';
import { FaLeaf, FaIndustry } from 'react-icons/fa';

function EmployeePage() {
  const navigate = useNavigate();
  const [employeeName, setEmployeeName] = useState('');

  useEffect(() => {
    const storedEmployee = JSON.parse(localStorage.getItem('user'));
    if (storedEmployee && storedEmployee.empname) {
      setEmployeeName(storedEmployee.empname);
    }
  }, []);

  const handleNavigation = (selection) => {
    if (selection === 'tea') navigate('/registertea');
    else if (selection === 'factory') navigate('/factoryreg');
  };

  return (
    <div className="employee-page">
      <h2>Welcome, {employeeName || 'Employee'}!</h2>
      <p>Select an option to proceed:</p>

      <div className="options">
        <div className="option-card" onClick={() => handleNavigation('tea')}>
          <FaLeaf size={50} color="#4ade80" />
          <div className="option-content">
            <h3>Register Tea</h3>
            <p>Click here to register tea details</p>
          </div>
        </div>

        <div className="option-card" onClick={() => handleNavigation('factory')}>
          <FaIndustry size={50} color="#60a5fa" />
          <div className="option-content">
            <h3>Factory Data</h3>
            <p>Click here to enter factory data</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeePage;
